import { render, staticRenderFns } from "./BetSlipTitle.vue?vue&type=template&id=f9beb390&"
import script from "./BetSlipTitle.vue?vue&type=script&lang=js&"
export * from "./BetSlipTitle.vue?vue&type=script&lang=js&"
import style0 from "./BetSlipTitle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports